import { Form, Input } from 'antd'
import React, { useEffect, useState } from 'react'

function ApplicationErrorDetails({ data }) {

    useEffect(() => {
        loadData();
    }, [data])

    const loadData = () => {
        form.setFieldsValue({
            appName: data.appName,
            browserName: data.browserName,
            errorTime: data.errorTime,
            message: data.message,
            mobile: data.mobile? 'Yes' : 'No',
            stackTrace: data.stackTrace
        })
    }
    const { TextArea } = Input;
    const [formLayout, setFormLayout] = useState('horizontal');

    const formItemLayout =
        formLayout === 'horizontal'
            ? {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            }
            : null;

    const formName = "ErrorDetailsForm";
    const [form] = Form.useForm();

    return (
        <>
            <Form
                {...formItemLayout}
                name={formName}
                form={form}
                layout="horizontal"
                initialValues={{
                    layout: formLayout,
                }}
                disabled
            >
                <Form.Item
                    name="appName"
                    label="Application Name"
                >
                    <Input name="appName" />
                </Form.Item>
                <Form.Item
                    name="browserName"
                    label="Browser Name"
                >
                    <Input name="browserName" />
                </Form.Item>
                <Form.Item
                    name="errorTime"
                    label="Date/Time"
                >
                    <Input name="errorTime" />
                </Form.Item>
                <Form.Item
                    name="mobile"
                    label="Mobile"
                >
                    <Input name="mobile" />
                </Form.Item>
                <Form.Item
                    name="message"
                    label="Error Message"
                >
                    <Input name="message" />
                </Form.Item>
                <Form.Item
                    name="stackTrace"
                    label="Error Description"
                >
                    <TextArea name="stackTrace" rows={10} />
                </Form.Item>
            </Form>
        </>
    )
}

export default ApplicationErrorDetails